import React from 'react';
import { render } from 'ink';
import App from './App.jsx';

// Function to run interactive mode
export default function runInteractive() {
  // Render the app with waitUntilExit to handle exit properly
  const { waitUntilExit } = render(<App />, {
    exitOnCtrlC: false  // Disable automatic exit on Ctrl+C
  });

  return waitUntilExit();
}

// Only run if this is the main module
if (import.meta.url === `file://${process.argv[1]}`) {
  runInteractive();
}